import React, { useEffect, useState } from "react"
import {
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  Button,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import api from "../../../utils/api"

interface Event {
  name: string
  description: string
  adminLimit: number
  numVoters: number
  //passwordReq: boolean
  endDate: Date
  startDate: Date
  archiveStatus: boolean
}

export const ArchiveEventPage: React.FC<{
  notification?: string
}> = ({ notification = "" }) => {
  const [events, setEvents] = useState<Event[]>([])
  const [selectedEvent, setSelectedEvent] = useState("")
  const [archiveStatus, setArchiveStatus] = useState(false)
  //Snackbar Code
  const [openSnackbar, setOpenSnackbar] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const handleSnackbarClose = () => setOpenSnackbar(false)

  useEffect(() => {
    fetchEvents("/admin/events", setEvents)
  }, [])
  const navigate = useNavigate()
  // useEffect for fetching selected event's data
  useEffect(() => {
    if (selectedEvent) {
      api
        .get(`/admin/events/${selectedEvent}`)
        .then((response) => {
          const eventData = response.data
          setArchiveStatus(eventData.archiveStatus)
        })
        .catch((error) => {
          console.error("Error fetching selected event data:", error)
        })
    }
  }, [selectedEvent])

  const handleArchiveEvent = async () => {
    try {
      await api.put(`/admin/events/${selectedEvent}/archive`, {
        archiveStatus: true,
      })

      navigate("/admin/dashboard", {
        state: { notification: "Event successfully archived!" },
      })
    } catch (error) {
      console.error("Error archiving event:", error)
      setErrorMessage("No Event selected.")
      setOpenSnackbar(true)
    }
  }

  useEffect(() => {
    fetchEvents("/admin/events", (data: any[]) => {
      const nonArchivedEvents = data.filter((event) => !event.archiveStatus) // Filter out archived events
      setEvents(nonArchivedEvents)
    })
  }, [])

  const fetchEvents = async (url: string, setter: (data: any[]) => void) => {
    try {
      const response = await api.get(url)
      const data = response.data
      setter(data)
    } catch (error) {
      console.error(`Error fetching data from ${url}:`, error)
    }
  }

  return (
    <>
      <Typography variant="h6" m={4}>
        Select Event to Archive
      </Typography>
      <EventDropdown
        events={events}
        selectedEvent={selectedEvent}
        onChange={setSelectedEvent}
      />

      <Button
        variant="contained"
        color="primary"
        style={{ marginTop: "20px", marginLeft: "16px" }}
        onClick={handleArchiveEvent}
        disabled={archiveStatus} // Disable the button if already archived
      >
        Archive Event
      </Button>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  )
}

const EventDropdown: React.FC<{
  events: any[]
  selectedEvent: string
  onChange: (val: string) => void
}> = ({ events, selectedEvent, onChange }) => (
  <FormControl fullWidth margin="normal" required>
    <InputLabel id="event-label">Event</InputLabel>
    <Select
      label="Event"
      labelId="event-label"
      value={selectedEvent}
      onChange={(e) => onChange(e.target.value)}
    >
      {events.length ? (
        events.map((event) => (
          <MenuItem key={event.id} value={event.id}>
            {event.name}
          </MenuItem>
        ))
      ) : (
        <MenuItem value="">No events available</MenuItem>
      )}
    </Select>
  </FormControl>
)
